import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as React from 'react'
import { newStore, RootState } from '@logic'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import 'react-datepicker/dist/react-datepicker.css'
import { Service } from '@src/service'
import { App } from '@src/app'
import { createBuzzLocalFixture, createBuzzLocalStateActions } from '@modules/messaging/services/buzz-local-fixture'

export interface AppConfig {
  api: {
    url: string
  }
  appName: string
  clientId: string
  tenantId: string
  mode: WebpackMode
  stubWebservice: boolean
}

export enum WebpackMode {
  development = 'development',
  production = 'production',
}

export type StateTransform<T> = (r: RootState) => T

function newApp(service: Service) {
  // TODO: Refactor the initialization of the redux to not require "addDispatch"

  // Hack to replace react-hot-loader with HMR (HMR will delete redux store without this)
  if (!(window as any).store) {
    const { store, history } = newStore(service)
    const buzzFixture = createBuzzLocalFixture(
      window.location.pathname,
      window.location.search,
      process.env.REACT_APP_BUZZ_FIXTURE_AUTH === 'true',
    )
    if (buzzFixture) {
      createBuzzLocalStateActions(buzzFixture).forEach((action) => store.dispatch(action as any))
    }
    Object.assign(window as any, { store, __equaHistory: history })
  }

  service.addDispatch((window as any).store.dispatch)

  return (
    <Provider store={(window as any).store}>
      <App history={(window as any).__equaHistory} service={service} />
    </Provider>
  )
}

declare const DISABLE_FULLSTORY: string

export function index(service: Service) {
  if (!DISABLE_FULLSTORY) (window as any).startFullStory()
  const app = newApp(service)
  const appContainer = document.getElementById('root')!
  const root = createRoot(appContainer)
  root.render(app as any)
}
